export enum DoctorStatus { draft = 'draft', published = 'published', suspended = 'suspended' }
export enum DoctorOnboardingPath { invite = 'invite', adminBuilt = 'admin_built' }

export interface Specialty {
    id: string
    name_en: string
    name_ar: string
    icon: string | null
    sort_order: number
    active: boolean
}

export interface DoctorProfile {
    id: string
    user_id: string
    email: string
    full_name: string
    title: string
    specialty_id: string | null
    specialty?: Pick<Specialty, 'id' | 'name_en' | 'name_ar'> & Partial<Pick<Specialty, 'active'>> | null
    status: DoctorStatus
    onboarding_path: DoctorOnboardingPath
    bio_en: string | null
    bio_ar: string | null
    photo_path: string | null
    languages: string[]
    license_number: string | null
    years_experience: number | null
    pricing_scheme: 'fixed'
    session_price_usd: number
    session_duration_min: number
    buffer_min: number
    timezone: string
    invited_at: string | null
    published_at: string | null
    created_at: string
    updated_at: string
}

export const DOCTOR_PROFILE_FIELDS = [
    'title', 'full_name', 'specialty_id', 'license_number', 'years_experience', 'languages',
    'bio_en', 'bio_ar', 'photo_path', 'session_price_usd', 'session_duration_min', 'buffer_min',
] as const

export type DoctorProfileFields = Pick<DoctorProfile, typeof DOCTOR_PROFILE_FIELDS[number]>

export interface TelemedicineSettings {
    telemedicine_enabled: boolean
    default_session_duration_min: number
    default_buffer_min: number
    patient_cancellation_window_hours: number
    doctor_cancellation_notice_hours: number
    no_show_grace_min: number
    payment_hold_min: number
    join_window_min: number
    reminder_offsets_min: number[]
}

export interface AvailabilityRule {
    id: string
    doctor_id: string
    weekday: number
    start_time: string
    end_time: string
}

export interface AvailabilityException {
    id: string
    doctor_id: string
    starts_at: string
    ends_at: string
    kind: 'blocked' | 'extra'
    note: string | null
}

export interface Slot {
    starts_at: string
    ends_at: string
}
